exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.btn-height[data-v-0f93f23f] {\n  height: 39px;\n}\n.tab-payments__send-link--sending[data-v-0f93f23f] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.tab-payments__invoice-section[data-v-0f93f23f] {\n  border-left: 1px solid #c5d0de;\n}\n.payment-legend[data-v-0f93f23f] {\n  gap: 0.5rem;\n  font-size: 0.75rem;\n  color: #6c757d;\n}\n.payment-legend__dot[data-v-0f93f23f] {\n    display: inline-block;\n    width: 0.65rem;\n    height: 0.65rem;\n    border-radius: 50%;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n}\n.payment-legend__label[data-v-0f93f23f] {\n    white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0f93f23f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEditV2/TabPayments/TabPayments.vue
// module id = 1946
// module chunks = 0